'use client';

// import { redirect } from 'next/navigation';
import { useSidebarStore } from "../hooks/sidebarStore";
import { Heading } from "../components/heading";
import { MaxWidthWrapper } from "../components/max-width-wrapper";
import { Check, Star } from "lucide-react"
import { ShinyButton } from "../components/shiny-button";
import { MockDiscordUI } from "../components/mock-discord-ui";
import { AnimatedList, AnimatedListItem } from "@/components/ui/animated-list";
import { DiscordMessage } from "../components/discord-message";
import Image from "next/image";
import Link from "next/link"
import { Icons } from "../components/icons";
import { ReviewCard } from "../components/ReviewCard";
import { useServiceReviews } from "@/app/hooks/useServiceReviews";
import Hero from "../components/Hero";
import PreSaveSection from "../components/PreSaveSection";
import { useServiceReviewModal } from "../hooks/useServiceReviewModal";
import ServiceReviewModal from "../components/modals/ServiceReviewModal";

import LeaveReviewButton from "../components/LeaveReviewButton";
// import YouTubeEmbed from "../components/YouTubeEmbed";

export default function Home() {
  // redirect('/shop');
  const { isCollapsed } = useSidebarStore()

  const modal = useServiceReviewModal();
  const { reviews, isLoading } = useServiceReviews();
  const serviceReviewModal = useServiceReviewModal();
  
    return (
      <div className={`transition-all duration-300 ${isCollapsed ? 'md:ml-16' : 'md:ml-64'}`}>        
        <section className="relative py-2 sm:py-4 bg-brand-25 rounded-lg shadow-lg">
          <Hero />

          <MaxWidthWrapper className="mt-10">
          <div className="grid gap-8 md:grid-cols-[minmax(0,2fr)_minmax(0,3fr)] items-center rounded-2xl border border-zinc-800 bg-zinc-950/90 p-6 sm:p-8 shadow-xl">
            {/* Texto / CTA */}
            <div className="space-y-4">
              <span className="inline-flex items-center rounded-full bg-emerald-500/10 px-3 py-1 text-xs font-semibold text-emerald-400 ring-1 ring-emerald-500/30">
                Novo lançamento • Nightreggaex
              </span>

              <h2 className="text-2xl sm:text-3xl font-bold text-zinc-50">
                Reggae I Wanna — álbum completo - LIVE - 2026
              </h2>

              <p className="text-sm sm:text-base text-zinc-300 leading-relaxed">
                Baixe a versão Deluxe do álbum do NIGHTREGGAEX disponível apenas aqui no site!
              </p>

              <p className="text-lg font-semibold text-emerald-400">
                Apenas <span className="text-2xl">R$ 199,90</span>
              </p>

              <div className="flex flex-wrap items-center gap-3">
                <Link href="/album/reggae-i-wanna">
                  <button className="inline-flex items-center justify-center rounded-full bg-emerald-500 px-5 py-2.5 text-sm font-semibold text-black hover:bg-emerald-400 transition">
                    Baixar Álbum
                  </button>
                </Link>

                <p className="text-xs sm:text-sm text-zinc-400">
                  Download imediato após a confirmação do pagamento via Pix.
                </p>
              </div>
            </div>

            {/* Imagens da capa */}
            <div className="grid grid-cols-2 gap-4">
              {/* Capa normal */}
              <div className="relative w-full aspect-square rounded-xl overflow-hidden border border-zinc-800">
                <Image
                  src="/cover.png"
                  alt="Capa do álbum Reggae I Wanna"
                  fill
                  className="object-cover"
                />
              </div>

              {/* Capa com lista de faixas */}
              <div className="relative w-full aspect-square rounded-xl overflow-hidden border border-zinc-800">
                <Image
                  src="/cover-list.png"
                  alt="Tracklist do álbum Reggae I Wanna"
                  fill
                  className="object-cover"
                />
              </div>
            </div>
          </div>
        </MaxWidthWrapper>
        <MaxWidthWrapper>
          <div className="items-center rounded-2xl border border-zinc-800 bg-zinc-950/90 p-6 sm:p-8 shadow-xl mt-4">
            <PreSaveSection spotifyUrl="https://open.spotify.com/intl-pt/album/3YskjpOdzwM2N2hPHAMD9A?si=I-ZKJfbNR9-rK6AFUCz1Kw" />
          </div>
        </MaxWidthWrapper>

          {/*<div className="grid gap-4 lg:grid-cols-3 lg:grid-rows-2 mt-2">
            <YouTubeEmbed 
              videoId="BUjYX_qe6so" />
            <YouTubeEmbed 
              videoId="Af3VkfKTWOU" />
            <YouTubeEmbed 
              videoId="0T1ydkVXlRU" />
          </div>*/}
            
          <MaxWidthWrapper className="text-center mt-16">
            <div className="relative mx-auto flex flex-col items-center gap-10">
              <div>
                <Heading>
                  <span>Insights em tempo real,</span>
                  <br />
                  <span className="bg-gradient-to-r from-brand-700 to-brand-800 text-transparent bg-clip-text mt-2">
                    Beckasmello também no seu Discord
                  </span>
                </Heading>
              </div>

              <div className="w-full max-w-[500px] mx-auto -mt-4"> 
                <div className="relative w-full aspect-[2685/409]">
                  <Image
                    src="/images/hitfastfx.png"
                    alt="Banner Discord Insights"
                    fill
                    sizes="(max-width: 768px) 100vw, 500px"
                    className="object-contain rounded-full"
                  />
                </div>
              </div>


              <p className="text-base/7 text-gray-600 max-w-prose text-center">O melhor jeito pra monitorar seus shows.
                Obtenha notificações de <span className="font-semibold text-gray-700">mensagens, novos usuários ou
                  qualquer outro evento
                </span>{" "}enviado diretamente pro seu Discord.
              </p>
  
              <ul className="space-y-2 text-base/7 text-gray-600 text-left">
                {["Alertas em tempo real para iniciação de eventos", 
                  "O cliente reservou? Você recebe uma notificação instantânea no Discord",
                  "Negocie os termos do contrato com o cliente via chat online aqui na plataforma",
                  ].map((item, index) => (
                    <li key={index} className="flex gap-1.5 items-center
                    text-left">
                      <Check className="size-5 shrink-0 text-brand-700" />
                      {item}
                    </li>
                  ))}
              </ul>
  
              <div className="flex flex-col md:flex-row gap-4 w-full max-w-80 justify-center mb-4">
                <ShinyButton href="/" className="relative h-14 w-full text-base shadow-lg transition-shadow duration-300 hover:shadow-xl">Comece agora</ShinyButton>
              </div>
            </div>
          </MaxWidthWrapper>
        </section>
  
        <section className="relative bg-brand-25 pb-4">
          <div className="absolute inset-x-0 bottom-24 top-24 bg-brand-700" />
          <div className="relative mx-auto">
            <MaxWidthWrapper className="relative">
              <div className="-m-2 rounded-xl bg-gray-900/5 p-2 ring-1
              ring-inset ring-gray-900/10 lg:-m-4 lg:rounded-2xl lg:p-4">
                <MockDiscordUI>
                  <AnimatedList>
                    <DiscordMessage 
                      avatarSrc="/natureggae.jpg"
                      avatarAlt="Natureggae Avatar" 
                      username="Natureggae Bot"
                      timestamp="Hoje às 12:10"
                      badgeText="Reserva"
                      badgeColor="#facc15"
                      title="📥 Gabriel caiu no reggae!"
                      content={{
                        "🏕️ Show de bola garoto": "💎",
                        "🙋‍♂️ Compra de": "Gabriel",
                        "📅 04/06": "Álbum do NIGHTREGGAEX",
                        "Status": "💳 Pagamento confirmado"
                      }}
                    />
                                        
                    <DiscordMessage 
                      avatarSrc="/natureggae.jpg"
                      avatarAlt="Natureggae Avatar" 
                      username="Natureggae" 
                      timestamp="Today at 12:35PM"
                      badgeText="Revenue"
                      badgeColor="#faa61a"
                      title="💰 Payment received"
                      content={{
                        amount: "$49.00",
                        email: "johndoetestsomewhere@gmail.com",
                        plan: "PRO",
                      }}
                    />
  
                    <DiscordMessage 
                      avatarSrc="/natureggae.jpg"
                      avatarAlt="Natureggae Avatar" 
                      username="Natureggae Bot"
                      timestamp="Hoje às 15:45"
                      badgeText="Reserva"
                      badgeColor="#43b581"
                      title="✅ Alô Steve!! Temos uma nova reserva te aguardando!"
                      content={{
                        "🏕️ Produto": "Festival de inverno",
                        "🙋 Cliente": "Matheu Ortiz",
                        "📅 Período": "2025-12-20 → 2025-12-22",
                        "💵 Valor": "R$ 1950,00",
                        "Status": "💳 Pagamento confirmado"
                      }}
                    />
                  </AnimatedList>
                </MockDiscordUI>
              </div>            
            </MaxWidthWrapper>
          </div>          
          
        </section>
  
        <section className="relative py-8 sm:py-16 bg-brand-25">          
          <div className="flex flex-col items-center text-center space-y-4 px-4">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800">
              🎧 Junte-se à nossa comunidade no Discord
            </h2>
            <p className="text-gray-600 max-w-prose">
              Participe das discussões, receba alertas de novos eventos e compartilhe suas experiências.
              Clicke no botão de convite abaixo!
            </p>
          
            <div className="flex justify-center">              
              <a
                href="https://discord.gg/Z2xvTfsEfS"
                target="_blank"
                rel="noopener noreferrer"
                className="h-14 px-6 flex items-center justify-center gap-2 bg-[#5865F2] text-white font-semibold rounded-md hover:bg-[#4752C4] transition-all"
              >
                <Icons.discord className="w-5 h-5" />
                Grupo do Discord
              </a>
            </div>
          </div>
          <MaxWidthWrapper className="flex flex-col items-center gap-16 sm:gap-20">
            <div>
              <h2 className="text-center text-base/7 font-semibold text-brand-600">
                  Monitoramento Intuitivo
              </h2>
              <Heading>Esteja um passo a frente</Heading>
            </div>
  
            <div className="grid gap-4 lg:grid-cols-3 lg:grid-rows-2">
              {/* first bento grid element */}
              <div className="relative lg:row-span-2">
                <div className="absolute inset-px rounded-lg bg-white lg:rounded-l-[2rem]" />
  
                <div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] lg:rounded-l-[calc(2rem+1px)]">
                  <div className="px-8 pb-3 pt-8 sm:px-10 sm:pb-0 sm:pt-10">
                    <p className="mt-2 text-lg/7 font-medium tracking-tight text-brand-950 max-lg:text-center">
                      Em Show você adiciona sua banda!
                    </p>
                    <p className="mt-2 max-w-lg text-sm/6 text-gray-600 max-lg:text-center">
                      Insira todas as informações relevantes sobre sua equipe, como
                      contato, cidade, foto, preço da reserva de pré-contrato e fique
                      atento às contratações!
                    </p>
                  </div>
  
                  <div className="relative min-h-[30rem] w-full grow [container-type:inline-size]
                  max-lg:mx-auto max-lg:max-w-sm]">
                    <div className="absolute inset-x-10 bottom-0 top-10 overflow-hidden rounded-t-[12cqw]
                    border-x-[3cqw] border-t-[3cqw] border-gray-700 bg-gray-900 shadow-2xl">
  
                      <Image className="size-full object-cover object-top" 
                        src="/phone-show.png"
                        alt="Phone screen displaying app interface"
                        fill 
                       />
                    </div>
                  </div>
                </div>
                
                <div className="pointer-events-none absolute inset-px rounded-lg
                  shadow ring-1 ring-black/5 lg:rounded-l-[2rem]" />
                </div>
  
              {/* Second bento grid element */}
              <div className="relative max-lg:row-start-1">
                <div className="absolute inset-px rounded-lg bg-white max-lg:rounded-t-[2rem]" />
                <div className="relative flex h-full flex-col overflow-hidden rounded=[calc(theme(borderRadius.lg)+1px)]
                max-lg:rounded-t-[calc(2rem+1px)]">
                  <div className="px-8 pt-8 sm:px-10 sm:pt-10">
                    <p className="mt-2 text-lg/7 font-medium tracking-tight text-brand-950 max-lg:text-center">
                      Contrate o melhor para o seu evento
                    </p>
                    <p className="mt-2 max-w-lg text-sm/6 text-gray-600 max-lg:text-center">
                      Faça a reserva de sua escolha, e inicie uma negociação. Se por qualquer motivo
                      a reserva não se tornar um contrato, você estorna o valor pago e poderá iniciar uma nova reserva
                      quantas vezes precisar!
                    </p>
                  </div>
                  <div className="flex flex-1 items-center justify-center px-8 max-lg:pb-12 max-lg:pt-10 sm:px-10 lg:pb-2">
                    <Image className="w-full max-lg:max-w-xs"
                      src="/bento-any-event.png"
                      alt="Bento box illustrating event tracking"
                      width={500}
                      height={300}  
                    />
                  </div>
                </div>
  
                <div className="pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5 max-lg:rouded-t-[2rem]" />
              </div>
                {/* Third bento grid element */}
              <div className="relative max-lg:row-3 lg:col-start-2 lg:row-start-2">
                <div className="absolute inset-px rounded-lg bg-white" />
                <div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)]">
                  <div className="px-8 pt-8 sm:px-10 sm:pt-10">
                    <p className="mt-2 text-lg/7 font-medium tracking-tight text-brand-950 max-lg:text-center">
                      Busque reconhecimento
                    </p>
                    <p className="mt-2 max-w-lg text-sm/6 text-gray-600 max-lg:text-center">
                      Seu trabalho e seus shows mostrado em video vai fazer
                      com que voce seja reconhecido em qualquer lugar!
                    </p>
                  </div>
                  <div className="flex flex-1 items-center justify-center px-8
                  max-lg:pb-12 max-lg:pt-10 sm:px-10 lg:pb-2">
                    <Image
                      className="w-full max-lg:max-w-xs"
                      src="/bento-custom-data.png"
                      alt="Bento box illustrating custom data tracking"
                      width={500}
                      height={300}
                    />
                  </div>
                </div>
  
                <div className="pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5" />
              </div>
  
              {/* fourth bento grid element */}
              <div className="relative lg:row-span-2">
                <div className="absolute inset-px rounded-lg bg-white max-lg:rounded-b-[2rem] lg:rounded-r-[2rem]" />
  
                <div className="relative flex h-full flex-col overflow-hidden rounded-[calc(theme(borderRadius.lg)+1px)] max-lg:rounded-b-[calc(2rem+1px)] lg:rounded-r-[calc(2rem+1px)]">
                  <div className="px-8 pb-3 pt-8 sm:px-10 sm:pb-0 sm:pt-10">
                    <p className="mt-2 text-lg/7 font-medium tracking-tight text-brand-950 max-lg:text-center">
                      Tudo muito fácil!
                    </p>
                    <p className="mt-2 max-w-lg text-sm/6 text-gray-600 max-lg:text-center">
                      O preço total da reserva será descontado no valor acordado do contrato!
                      No dashboard gerencie seus créditos e ganhos, suas reservas e contratos, e muito mais!
                    </p>
                  </div>
  
                  <div className="relative min-h-[30rem] w-full grow">
                      <div className="absolute bottom-0 left-10 right-0 top-10 overflow-hidden
                      rounded-tl-xl bg-gray-900 shadow-2xl">
                        <Image className="size-full object-cover object-top" 
                          src="/phone-dash.png"
                          alt="Phone screen displaying app interface"
                          fill 
                        />         
                    </div>
                  </div>
                </div>
  
                <div className="pointer-events-none absolute inset-px rounded-lg shadow ring-1 ring-black/5 max-lg:rounded-b-[2rem] lg:rounded-r-[2rem]" />
              </div>
            </div>
          </MaxWidthWrapper>
        </section>
  
        <section className="relative py-24 sm:py-32 bg-white">
          <MaxWidthWrapper className="flex flex-col items-center gap-16 sm:gap-20">

            {isLoading && (
              <div className="text-center text-gray-600">Carregando...</div>
            )}

            {!isLoading && reviews.length === 0 && (
              <div className="text-center text-gray-500">
                Nenhuma avaliação ainda.  
                <br />
                Seja o primeiro a compartilhar sua experiência!
              </div>
            )}

            {!isLoading && reviews.length > 0 && (
              <div className="mx-auto grid max-w-2xl grid-cols-1 px-4 lg:mx-0 lg:max-w-none lg:grid-cols-2 divide-y lg:divide-y-0 lg:divide-x divide-gray-200">
                {reviews.map((review: any, i: number) => (
                  <ReviewCard
                    key={review.id}
                    rating={review.rating}
                    text={review.comment}
                    userName={review.user_name || "Anônimo"}
                    username={(review.user_name || "anônimo").toLowerCase().replace(/\s+/g, "")}
                    avatar={review.user_avatar || "/user-1.png"}
                    className={
                      i === 0
                        ? "rounded-t-[2rem] lg:rounded-tr-none lg:rounded-l-[2rem]"
                        : "rounded-b-[2rem] lg:rounded-bl-none lg:rounded-r-[2rem]"
                    }
                  />

                ))}
              </div>
            )}

            {/* 🔥 Botão seguro e com verificação de login */}
            <LeaveReviewButton className="px-6 py-3 rounded-full bg-brand-600 text-white shadow hover:bg-brand-500 transition" />

            {/* 🔥 Modal ligado ao Zustand */}
            <ServiceReviewModal
              isOpen={serviceReviewModal.isOpen}
              onClose={serviceReviewModal.close}
            />
            {/* Ícone de alerta (controlador) */}
            <div className="relative -mt-1">
              <button
                className="peer px-3 py-1 text-yellow-600 text-4xl select-none"
              >
                ⚠
              </button>

              <div
                className="
                  opacity-0 pointer-events-none scale-95 
                  peer-hover:opacity-100 peer-hover:pointer-events-auto peer-hover:scale-100 
                  peer-focus:opacity-100 peer-focus:pointer-events-auto peer-focus:scale-100
                  transition-all duration-300
                  absolute left-1/2 -translate-x-1/2 top-full
                  mt-2 max-w-[90vw]
                  p-6 bg-green-300 shadow-xl rounded-2xl border border-gray-200
                  z-20
                "
              >
                <h3 className="text-lg font-bold text-gray-800 mb-4">📸 Avatar</h3>
                <p className="text-sm">
                  Acesse Configurações no ícone ⚙
                  Adicione seu apelido.
                  Em Avatar faça upload de sua foto! MAX.: 1MB.
                </p>
              </div>
            </div>
            <div className="flex justify-center py-6">
               <img
                 src="/images/hitfastfx.png"
                 alt="Banner do Festival RockBluesReggae - Baixe o App"
                 className="rounded-xl shadow-lg max-w-full h-auto"
              />
            </div>
          </MaxWidthWrapper>
        </section>    
      </div>
    );
  }
